import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { SidebarMenuItemContainer } from '../SidebarMenuItem/styled';
import { ICON_CONTAINER_WIDTH, LOGOTYPE_PADDING } from '../config';
export const SidebarMenuCollapsibleItemContainer = styled(SidebarMenuItemContainer) `
  min-height: ${ICON_CONTAINER_WIDTH};
  margin-left: calc(${ICON_CONTAINER_WIDTH} - ${LOGOTYPE_PADDING});
  padding: 0 ${LOGOTYPE_PADDING};

  ${(props) => props.$isMenuChild &&
    `
    width: calc(100% - ${themeGet('spacing.sm')} * 2);
    padding-right: ${pxToRem(32)};
    margin: ${themeGet('spacing.sm')};
  `}

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: calc((${LOGOTYPE_PADDING} + ${pxToRem(2)} / 2) * -1);
    width: ${pxToRem(1)};
    height: 150%;
    background-color: ${themeGet('colors.gray.100')};
  }

  &:first-of-type:not(:last-of-type)::after {
    top: 25%;
  }

  &:last-of-type:not(:first-of-type)::after {
    height: 75%;
  }
`;
